import React from 'react';
import './home.css';
import DashboardCharts from 'components/Charts/DashBoardCharts';

function Home() {
  return (
    <div className='home'>
      <DashboardCharts />
    </div>
  );
}

export default Home;
